{
  " Invoice including VAT means that all items in the invoice will be listed with their prices including VAT": "Facture incluant la TVA signifie que tous les articles de la facture seront listés avec leurs prix incluant la TVA",
  "& next": " & suivant",
  "A réception de la facture": "On receipt of the invoice",
  "Accept": "Accepter",
  "Accept document": "Accepter document",
  "Accept documents": "Accepter documents",
  "accepted": "Accepté",
  "Accepted": "Accepté",
  "ACCEPTED": "Accepté",
  "Accepted format: .csv, .xls and .xlsx;": "Formats acceptés: .csv, .xls et .xlsx;",
  "Accepted payment methods": "Modes de paiement acceptés",
  "Accepted successfully": "Acceptée avec succès",
  "accepted_format": "Formats acceptés: .csv, .xls et .xlsx;",
  "Account": "Compte",
  "Account Number": "Numéro de Compte",
  "Account prefix": "Préfixe",
  "Accountant": "Comptable",
  "Accountant Transfer": "Transfert de facturation",
  "Accounting": "Paramètres comptables",
  "Accounting firm": "Cabinet",
  "Accounting Firm": "Cabinet",
  "Accounting information": "Informations comptables",
  "Accounting setup": "Configuration comptable",
  "Accounts": "Comptes",
  "action": "Action",
  "Action": "Action",
  "Actions": "Actions",
  "Active": "Actif",
  "Activity": "Activités",
  "Add": "Créer",
  "Add a bank account and mark it as main, then create a SEPA mandate.": "Ajoutez un compte bancaire et définissez-le comme principal, puis créez un mandat SEPA.",
  "ADD A DOCUMENT (PDF - 2 MB)": "AJOUTER UN DOCUMENT (PDF - 2 MO)",
  "Add a note or legal mention...": "Ajouter une note ou une mention légale...",
  "Add account": "Ajouter un compte",
  "Add address": "Ajoutez adresse",
  "Add bank": "Ajouter banque",
  "Add bank account": "Ajouter un compte bancaire",
  "Add category": "Ajouter un famille de produits",
  "Add client": "Ajouter un client",
  "Add comment": "Ajouter un commentaire",
  "Add contact": "Ajouter un contact",
  "Add currency": "Ajouter devise",
  "Add date": "Ajouter date",
  "Add delivery": "Ajouter livraison",
  "Add email": "Ajouter email",
  "Add end line": "Ajouter saut de ligne",
  "Add end page": "Ajouter saut de page",
  "Add livraison": "Ajouter livraison",
  "Add new attachment": "Ajouter une pièce jointe",
  "Add payment": "Ajouter un paiement",
  "Add payment in advance": "Ajouter une facture d'acompte",
  "Add periodic billing": "Ajouter une facturation périodique",
  "Add phone": "Ajouter numéro de téléphone",
  "Add return": "Ajouter avoir",
  "Add sale account": "Ajouter ventilation comptable",
  "Add sale vat": "Ajouter ventilation de TVA",
  "Add sepa order": "Ajouter un mandat",
  "Add subtotal": "Ajouter sous-total",
  "Add template": "Ajouter modèle",
  "Add title": "Ajouter titre",
  "Add VAT": "Ajouter TVA",
  "Add vat type": "Ajouter type de TVA",
  "Additional address": "Complément d'adresse",
  "Address": "Adresse",
  "Address Nr": "N° d'adresse",
  "Advance payment issued counterpart": "Compte de demandes d’acomptes émis",
  "Advance payment issued tva counterpart": "Compte de TVA collectée pour les acomptes",
  "Advance payment percentage": "Pourcentage d'acompte",
  "Advance payment received counterpart": "Compte de demandes d’acomptes reçus",
  "Advance payment received tva counterpart": "Compte TVA acomptes reçus",
  "after_validation": "après validation",
  "after_x_days": "chaque x jours",
  "All": "Tout",
  "All column headers must be in French exactly as shown above": "Tous les en-têtes de colonne doivent être en français exactement comme indiqué ci-dessus",
  "All done": "Terminé",
  "amount": "montant",
  "Amount": "Montant",
  "Amount should less or equal of document amount.": "Le montant doit être inférieur ou égal au montant du document.",
  "Amount to be deducted": "Montant à déduire",
  "An error occurred, please refresh the page or click the button below": "Une erreur s'est produite, veuillez actualiser la page ou cliquer sur le bouton ci-dessous",
  "An unexpected error occurred processing your request, please try again later.": "Certains documents ne sont pas classés. Veuillez les examiner et leur attribuer un type dans la catégorie « Autres ».",
  "Analytical type": "Type analytique",
  "annulled": "Annulé",
  "Annulled": "Annulé",
  "ANNULLED": "Annulé",
  "Anull": "Annuler",
  "Anull document": "Annuler document",
  "Anulled": "Annulé",
  "Anuller": "Annuler",
  "Archive": "Désactiver",
  "Archive payment date limit": "Limite date de paiement",
  "Archive product": "Archive product / service",
  "Archived at": "Désactivé le",
  "Are you sure about delete this account?": "Vous êtes sûr de vouloir supprimer ce compte ?",
  "Are you sure about delete this address?": "Êtes-vous sûr de vouloir supprimer adresse ?",
  "Are you sure about delete this bank account?": "Êtes-vous sûr de la suppression de ce compte bancaire ?",
  "Are you sure about delete this category?": "Etes-vous sûr de vouloir supprimer cette catégorie ?",
  "Are you sure about delete this client?": "Êtes-vous sûr de vouloir supprimer ce client ?",
  "Are you sure about delete this comment?": "Êtes-vous sûr de vouloir supprimer ce commentaire ?",
  "Are you sure about delete this contact?": "Êtes-vous sûr de vouloir supprimer ce contact ?",
  "Are you sure about delete this email?": "Êtes-vous sûr de vouloir supprimer cet email ?",
  "Are you sure about delete this payment?": "Êtes-vous sûr de supprimer ce paiement ?",
  "Are you sure about delete this phone?": "Êtes-vous sûr de vouloir supprimer ce numéro de téléphone ?",
  "Are you sure about delete this product?": "Vous êtes sûr de vouloir supprimer ce produit / service?",
  "Are you sure about delete this sale account?": "Vous êtes sûr de vouloir supprimer ce ventilation ?",
  "Are you sure about delete this sale vat?": "Vous êtes sûr de vouloir supprimer ce ventilation ?",
  "Are you sure about delete this template?": "Êtes-vous sûr de vouloir supprimer ce modèle ?",
  "Are you sure about delete this vat?": "Voulez-vous vraiment supprimer cette TVA ?",
  "Are you sure you want to accept this document?": "Êtes-vous sûr de vouloir accepter ce document ?",
  "Are you sure you want to anull this document?": "Êtes-vous sûr de vouloir annuler ce document ?",
  "Are you sure you want to archive this deadline ?": "Êtes-vous sûr de vouloir archiver cette date limite ?",
  "Are you sure you want to archive this product ?": "Êtes-vous sûr de vouloir archiver ce produit / service?",
  "Are you sure you want to delete this attachment?": "Êtes-vous sûr de vouloir supprimer cette pièce jointe ?",
  "Are you sure you want to delete this billing ?": "Êtes-vous sûr de vouloir supprimer cette facturation ?",
  "Are you sure you want to delete this bulk?": "Êtes-vous sûr de vouloir supprimer ce lot?",
  "Are you sure you want to delete this delivery?": "Êtes-vous sûr de vouloir supprimer ce rémise?",
  "Are you sure you want to delete this document?": "Êtes-vous sûr de vouloir supprimer ce document ?",
  "Are you sure you want to leave without saving the value?": "Vous êtes sûr de vouloir partir sans sauvegarder la valeur ?",
  "Are you sure you want to move the bulk to Neoscan Expert?": "Êtes-vous sûr de vouloir déplacer le lot vers Neoscan Expert?",
  "Are you sure you want to move the bulk to SSI?": "Êtes-vous sûr de vouloir déplacer le lot vers SSI?",
  "Are you sure you want to produce this document?": "Êtes-vous sûr de vouloir produire ce document ?",
  "Are you sure you want to reactivate this deadline ?": "Êtes-vous sûr de vouloir réactiver ce délai ?",
  "Are you sure you want to reactivate this product ?": "Êtes-vous sûr de vouloir réactiver ce produit / service?",
  "Are you sure you want to refuse this document?": "Êtes-vous sûr de vouloir refuser ce document ?",
  "Are you sure you want to resume this periodic payment ?": "Êtes-vous sûr de vouloir reprendre ce paiement périodique ?",
  "Are you sure you want to stop this billing ?": "Vous êtes sûr de vouloir arrêter cette facturation ?",
  "Are you sure you want to validate this document?": "Êtes-vous sûr de vouloir valider ce document ?",
  "Are you sure, that you want to delete?": "Êtes-vous sûr de vouloir supprimer",
  "Assets": "Avoirs",
  "Assets format": "Avoir",
  "Assign saved with success": "Attribution enregistrée avec succès",
  "ATC": "ATC",
  "Attach the document in PDF": "Joindre le document au format PDF",
  "Attach the documents as an attachment to the email": "Joindre les documents en pièce jointe à l'email",
  "Attachment": "Pièce jointe",
  "Attachment deleted": "Pièce jointe supprimée",
  "Attachments": "Pièces jointes",
  "Attachments will always be available on the client interface, accessible from the email.": "Les pièces jointes seront toujours disponibles sur l'interface client, accessible depuis l'email.",
  "auto": "automatique",
  "Auto exported": "Exportation automatique",
  "Automatic reminder": "Relance automatique",
  "Automations": "Automations",
  "Available units": "Unités disponibles",
  "Avoid numbering without separators such as": "Évitez les numérotations sans séparateurs tels que",
  "Back": "Retour",
  "Background": "Fond",
  "Balance": "Solde",
  "Balance History": "Historique des soldes",
  "Balance Overview": "Aperçu des soldes",
  "Bank": "Banque",
  "Bank account": "Compte bancaire",
  "Bank account for invoices": "Compte bancaire pour les factures",
  "Bank accounts": "Comptes bancaires",
  "Bank default": "Banque principale",
  "Bank description": "Description banque",
  "Bank informations": "Informations bancaires",
  "Bank name": "Nom de la banque",
  "Banks": "Banques",
  "Base Color": "Base",
  "Before importing products, you must create or import product families (product types). Without existing product families, the import will fail. Each product must be associated with a valid product family reference.": "Avant d'importer des produits, vous devez créer ou importer des familles de produits (types de produits). Sans familles de produits existantes, l'importation échouera. Chaque produit doit être associé à une référence de famille de produits valide.",
  "Beginning day": "Jour de début",
  "Best-selling categories": "Catégories les plus vendues",
  "Best-selling Categories": "Meilleures catégories",
  "Best-selling products": "Articles les plus vendus",
  "Best-selling Products": "Meilleurs produits",
  "BIC": "BIC",
  "BIC is missing": "Le BIC est manquant",
  "Billing": "Facturation",
  "BILLING": "FACTURATION",
  "Billing address": "Adresse de facturation",
  "Billing and payment": "Facturation et paiement",
  "Billing method": "Mode de facturation",
  "Birthdate": "Date de naissance",
  "Body": "Contenu",
  "Book": "Journaux",
  "Border": "Bordure",
  "Breakdown account - Europe": "Compte de vente - Europe",
  "Breakdown account - Export": "Compte de vente - Export",
  "BTQ": "BTQ",
  "budget": "Devis",
  "Budget": "Devis",
  "BUDGET": "Devis",
  "budget accepted": "devis accepté(s)",
  "Budget format": "Devis",
  "Budget number": "Prochain nº de devis",
  "Budget/Order reminder": "Relance Devis/Commande",
  "Bulk deleted with success": "Lot supprimé avec succès",
  "Bulks not validated": "Lot non validé",
  "Bulks validated": "Lot validé",
  "by": "by",
  "C. de vente - Europe": "C. de vente - Europe",
  "C. de vente - Export": "C. de vente - Exportation",
  "Cancel": "Annuler",
  "Cancel payment": "Annuler paiement",
  "Cannot be accepted": "Ne peut être accepté",
  "Cannot be produced": "Ne peut être produit",
  "Cannot be validated": "Ne peut pas être validé",
  "Cannot exceed {{max}}%": "Ne peut pas dépasser {{max}}%",
  "Cannot exceed the total amount": "Ne peut pas dépasser le montant total",
  "Capital": "Capital social ",
  "Catalog": "Catalogue",
  "Categories": "Famille produits / services",
  "Category": "Catégorie",
  "Category references must match existing categories in your system": "Les références de catégories doivent correspondre aux catégories existantes dans votre système",
  "Change": "Changer",
  "Change Bulk": "Changer lot",
  "Change Delivery": "Changement de rémise",
  "Choir": "Chorus",
  "Choose template": "Choisir le modèle",
  "Chorus": "Chorus",
  "City": "Ville",
  "Clear selection": "Effacer la sélection",
  "Client": "Client",
  "Client account": "Compte client",
  "Client automatic numbering": "Numérotation automatique des clients",
  "Client counterpart": "Compte client par défault",
  "Client format": "Client format",
  "Client have documents associated.": "Le client a des documents associés.",
  "Client Information": "Informations client",
  "Client number": "Nº de client",
  "Client support": "Support Client",
  "Client type": "Type de client",
  "Client vat type": "Type TVA client",
  "Client vat types": "Types TVA des clients",
  "Clients": "Clients",
  "Close": "Fermer",
  "Code": "Code",
  "Code APE": "Code APE",
  "COFI": "COFI",
  "Collected": "Prélevé",
  "Collection sheet": "F. coll.",
  "Comment": "Commentaire",
  "Comments": "Commentaires",
  "Company": "Dossier",
  "Company info": "Informations entreprise",
  "Company Information": "Informations entreprise",
  "Company informations": "Informations sur l'entreprise",
  "Company logo": "Logo d'entreprise",
  "Company name": "Nom de l'entreprise",
  "Company name or Client name": "Nom de l'entreprise ou du client",
  "Company not found": "Entreprise introuvable",
  "compensation mandatory on commercial invoices since 2013": "compensation obligatoire sur les factures commerciales depuis 2013",
  "Compte client": "Compte client",
  "Configuration": "Configuration",
  "Configuration needed": "Configuration nécessaire",
  "Configure client": "Configurer le client",
  "Confirm": "Confirmer",
  "CONFIRMATION": "CONFIRMATION",
  "Contact": "Contact",
  "Contact details": "Coordonnées de contact",
  "Contacts": "Contacts",
  "Counter Collective": "Compte Collectif",
  "Counterpart": "Contrepartie",
  "Counterpart allocation type": "Type d'allocation de ventilation",
  "Counterpart code": "Compte",
  "Counterpart product": "Compte produit",
  "Counterpart VAT": "Compte TVA",
  "Counterparte VAT": "Compte TVA",
  "Country": "Pays",
  "Create": "Créer",
  "Create a budget": "Créer un devis",
  "Create a delivery note": "Créer un bon de livraison",
  "Create a return": "Créer une avoir",
  "Create an invoice": "Créer une facture",
  "Create an order": "Créer une commande",
  "Create bank": "Créer une banque",
  "Create client": "Créer un client",
  "Create compte": "Créer un compte",
  "Create Document": "Créer un document",
  "Create invoice": "Créer facture",
  "Create payment date": "Créer une échéance",
  "Create product": "Créer produit / service",
  "Create product / service": "Créer produit / service",
  "Created": "Créé",
  "Credit": "Crédit",
  "Currencies": "Devises",
  "Currency": "Devise",
  "Currency Tracking": "Suivi des devises",
  "Current Balance": "Solde actuel",
  "Custom template": "Modèle personnalisé",
  "Customization": "Personnalisation",
  "Customize your dashboard by toggling widgets on/off and reordering them by drag and drop.": "Personnalisez votre tableau de bord en activant ou désactivant les widgets et en les réorganisant par glisser-déposer.",
  "Cycle": "Exercice",
  "Cycles": "Exercices",
  "Dashboard": "Synthèse",
  "Dashboard Settings": "Paramètres du tableau de bord",
  "Date": "Date",
  "Date - Time": "Date - Heure",
  "Date d'échéance": "Date d'échéance",
  "Date d'emmission": "Date d'emmission",
  "Date de fin": "Date de fin",
  "Date de signature du mandat": "Date de signature du mandat",
  "Date/Time": "Date/Heure",
  "Day": "Jour",
  "Days": "Jours",
  "days_ago": " il y a {{ diffDaysAgo }} jours",
  "Deadline": "Date limite",
  "Deadline date": "Date d'échéance",
  "Deadline payment": "Paiement à l'échéance",
  "Debit": "Débit",
  "Debits": "Prélèvements",
  "Decimal cases": "Nombre de décimales",
  "Decimal places": "Décimales devise",
  "Decimal places for quantities": "Nombre de décimales pour les quantités",
  "Decimal places for quantity": "Décimales quantité",
  "Decimals for the unit price": "Nombre de décimales pour le prix unitaire HT",
  "Decline": "Refuser",
  "Default bank account": "Compte bancaire par défaut",
  "Default clients counterparts": "Collectif Client par défaut",
  "Default Counterpart": "Contreparties par défaut",
  "Default Counterparts": "Transfert de facturation",
  "Default price type (HT/TTC)": "Type de prix par défaut (HT/TTC)",
  "Default providers counterparts": "Collectif Fournisseur par défaut",
  "default_price_type_HT": "HT  : Cette option permet de Facturer classiquement en HT . Le calcul se fera en ajoutant la Tva. Le prix dans la fiche Produits sera à donner en HT (il sera possible de le modifier ponctuellement sur l’article).",
  "default_price_type_TTC": "TTC : Cette option permettra de facturer en TTC. Le prix dans la fiche Produits sera à donner en TTC. Le logiciel recalculera le HT en fonction du taux de TVA.",
  "Delete": "Supprimer",
  "Delete account": "Supprimer compte",
  "Delete address": "Supprimer l'adresse",
  "Delete bank account": "Supprimer le compte bancaire",
  "Delete billing": "Supprimer la facturation",
  "Delete Bulk": "Supprimer lot",
  "Delete category": "Supprimer la catégorie",
  "Delete client": "Supprimer client",
  "Delete comment": "Supprimer commentaire",
  "Delete contact": "Supprimer le contact",
  "Delete document": "Supprimer document",
  "Delete documents": "Supprimer documents",
  "Delete email": "Supprimer email",
  "Delete image": "Supprimer l'image",
  "Delete payment": "Supprimer le paiement",
  "Delete phone": "Supprimer numéro de téléphone",
  "Delete product": "Supprimer le produit / service",
  "Delete sale account": "Supprimer ventilation",
  "Delete sale vat": "Supprimer ventilation",
  "Delete template": "Supprimer modèle",
  "Delete vat": "Supprimer la TVA",
  "Deleted Successfully": "Supprimée avec succès",
  "Deliveries": "Livraisons",
  "Deliveries not validated": "Rémises non validées",
  "Deliveries validated": "Rémises validées",
  "delivery": "Bon de livraison",
  "Delivery": "Livraison",
  "DELIVERY": "LIVRAISONS",
  "Delivery address": "Adresse de livraison",
  "Delivery address details": " Détails de l'adresse de livraison",
  "Delivery cost counterpart": "Compte de frais de livraison",
  "Delivery deleted with success": "Rémise supprimée avec succès",
  "Delivery form": "Livraison",
  "Delivery format": "Bon de livraison",
  "delivery note": "bon de livraison",
  "Delivery number": "Prochain nº de livraison",
  "DELIVERY_FORM": "Livrasons",
  "Description": "Description",
  "Description on document": "Description sur le document",
  "Deselect all": "Tout désélectionner",
  "Designation": "Désignation",
  "Désignation": "Désignation",
  "Devise": "Devise",
  "Disc": "Rem",
  "Discard and continue": "Abandonner et continuer",
  "Discount": "Remise",
  "DISCOUNT": "REMISE",
  "Discount comment": "Remarque sur escompte",
  "Display": "Affichage",
  "Display documents": "Afficher les documents",
  "Display format": "Format d'affichage",
  "Display name": "Nom d'affichage",
  "Display the line signature and company stamp on the PDF": "Afficher la ligne signature et cachet de l'entreprise sur le PDF",
  "Do export": "Exporter",
  "Do you want to validate?": "Voulez-vous valider ?",
  "Document": "Piéce",
  "Document creation": "Création de document",
  "Document formats": "Formats de documents",
  "Document modification": "Modification de document",
  "Document name": "Nom du document",
  "Document Name": "Nom du document",
  "Document template": "Modèle de document",
  "Document types": "Types de documents",
  "Document(s)": "Document(s)",
  "document(s) selected": "{{nrDocuments}} document(s) sélectionné(s)",
  "documents": "pièces",
  "Documents": "Documents",
  "Documents below could not be validated. Please try to produce manually.": "Les documents ci-dessous n'ont pas pu être validés. Veuillez essayer de produire manuellement.",
  "Documents below could not be validated. Please try to validate manually.": "Les documents ci-dessous n'ont pas pu être validés. Veuillez essayer de valider manuellement.",
  "documents selected": "document(s) sélectionné(s)",
  "documentsReadyForExport": "documents prêts à être exportés",
  "Download": "Télécharger",
  "Download the model file for a template with all available columns": "Télécharger le fichier modèle pour un modèle avec toutes les colonnes disponibles",
  "drafted": "Brouillon",
  "Drafted": "Brouillon",
  "DRAFTED": "Brouillon",
  "Draw your signature below": "Dessinez votre signature ci-dessous",
  "Dunning invoice Level 1": "Relance Facture niveau 1",
  "Dunning invoice Level 2": "Relance Facture niveau 2",
  "Dunning invoice Level 3": "Relance Facture niveau 3",
  "Dunning reminders for unpaid invoices": "Relances automatiques pour les factures impayées",
  "DUPLICATA": "DUPLICATA",
  "Duplicate": "Dupliquer",
  "Duplicate document preview": "Aperçu du document en double",
  "Duplicate documents": "Dupliquer documents",
  "Duplicated Successfully": "Dupliqué avec succès",
  "Duration of validity (days)": "Durée de validité (jours)",
  "Duration of validity in days (Budget and Orders)": "Durée de validité en jours (Devis et Commandes)",
  "E-MAIL": "E-MAIL",
  "early payment discount terms": "conditions d'escompte pour paiement anticipé",
  "Echéance": "Echéance",
  "Échéance": "Échéance",
  "Échéance par défaut": "Échéance par défaut",
  "Edit": "Modifier",
  "Edit address": "Modifier l'adresse",
  "Edit bank": "Editer banque",
  "Edit bank account": "Modifier compte bancaire",
  "Edit category": "Editer la catégorie",
  "Edit Client": "Modifier client",
  "Edit comment": "Modifier commentaire",
  "Edit compte": "Modifier compte",
  "Edit contact": "Modifier le contact",
  "Edit email": "Modifier email",
  "Edit export configuration": "Modifier configuration d'exportation",
  "Edit phone": "Modifier numéro de téléphone",
  "Edit settings": "Modifier les paramètres",
  "Edit Settings": "Modifier les paramètres",
  "Electronic address PA": "Adresse électronique PA",
  "Electronic address used to send invoices to the public platform": "Adresse électronique utilisée pour envoyer les factures à la plateforme publique",
  "Email": "Email",
  "Email address": "Adresse électronique",
  "Email attachments": "Pièces jointes e-mail",
  "Email configuration keywords": "Mots clés de configuration d'e-mail",
  "Email settings": "Paramètres d'e-mail",
  "Email template for budget documents": "Modèle d'e-mail pour les devis",
  "Email template for grouped document reminders": "Modèle d'e-mail pour les relances de documents groupés",
  "Email template for invoices": "Modèle d'e-mail pour les factures",
  "Email template for payment acknowledgements": "Modèle d'e-mail pour les accusés de réception de paiement",
  "Email template for sale orders and reminders": "Modèle d'e-mail pour les commandes et relances",
  "Emails": "Emails",
  "Emails sent": "Emails envoyés",
  "Emails status": "Statut emails",
  "Empty cells are allowed for non-required fields": "Les cellules vides sont autorisées pour les champs non obligatoires",
  "Enable features": "Activer les fonctionnalités",
  "End": "Fin",
  "End date": "Date de fin",
  "End line": "Saut de ligne",
  "End page": "Saut de page",
  "English": "Anglais",
  "Enter product name": "Entrez nom du produit",
  "Enter reference": "Entrer référence",
  "ENTREPRISE": "Entreprise",
  "Error": "Erreur",
  "Error code": "Code d'erreur",
  "Error loading options": "Options de chargement d'erreur",
  "Error opening document, please contact administrator": "Erreur lors de l'ouverture du document, veuillez contacter l'administrateur.",
  "Errors": "Erreurs",
  "Escompte": "Escompte",
  "Estimated amount": "Montant devisé",
  "Etat": "État",
  "Eu sell counterpart": "Compte de ventes par défaut pour l'UE",
  "Evolution of the business": "Evolution de l'activité",
  "Evolution of the Business": "Évolution de l'entreprise",
  "Example": "Exemple",
  "Examples": "Exemples",
  "expired": "Expiré",
  "Expired": "Expiré",
  "expired budgets": "budgets expirés",
  "Export": "Exporter",
  "Export all documents": "Exporter tous les documents",
  "Export all documents to Excel": "Exporter tous les documents vers Excel",
  "Export configuration": "Configuration d'exportation",
  "Export error": "Erreur d'exportation",
  "Export Errors": "Erreurs d'exportation",
  "Export message": "Message d'exportation",
  "Export selected documents": "Exporter documents sélectionnés",
  "Export selected documents to Excel": "Exporter les documents sélectionnés vers Excel",
  "Exported": "Exporté",
  "Exports": "Exportations",
  "Exports history": "Historique des exportations",
  "Extra information": "Informations supplémentaires",
  "FACT-AAMM-XXXX will give a number for the fourteenth invoice issued on 7 January 2023 - FACT- 2301-0014": "FACT-AAMM-XXXX donnera un numéro pour la quatorzième facture émise en date du 7 janvier 2023 - FACT- 2301-0014",
  "Fax": "Fax",
  "Features": "Fonctionnalités",
  "Fiche": "Fiche",
  "Fichier PDF du mandat": "Fichier PDF du mandat",
  "File": "Fichier",
  "File download": "Téléchargement de fichier",
  "Filters": "Filtres",
  "Finish": "Finir",
  "First generation": "Première génération",
  "First generation is the first billing date for this invoice which will be generated periodically according to the defined Frequency. It also defines the anniversary day of the due dates. For a monthly frequency and a first generation date of 04/09, the invoices will be generated on 04/09 then 04/10, then 04/11...)": "Première génération est la première date de facturation pour cette facture qui sera générée périodiquement selon la Fréquence définie. Elle définit aussi le jour anniversaire des échéances Pour une fréquence mensuelle et une date de première génération au 04/09, les factures seront générées le 04/09 puis le 04/10, puis le 04/11...)",
  "Fixed recovery fee": "Frais de recouvrement fixe",
  "Follow ups": "Relances",
  "Fonts": "Polices",
  "Footer": "Pied de page",
  "for": "pour",
  "For a better experience, please complete the configuration in the Address and Bank accounts tabs.": "Pour une meilleure expérience, veuillez compléter la configuration dans les onglets Adresses et Comptes bancaires.",
  "For a better experience, please complete the configuration in the Address and Payments tabs.": "Pour une meilleure expérience, veuillez compléter la configuration dans les onglets Adresses et Paiements.",
  "For a better experience, please complete the configuration in the Bank accounts tabs.": "Pour une meilleure expérience, veuillez compléter la configuration dans les onglets Comptes bancaires.",
  "for an amount of": "d'un montant de",
  "For an amount of": "Pour un montant de",
  "For example, FACT-AAMM-XXXX will give a number for the fourteenth invoice issued on 7 January 2023 - FACT- 2301-0014": "Par exemple, FACT-AAMM-XXXX donnera un numéro pour la quatorzième facture émise en date du 8 mai 2023: FACT- 2305-0014",
  "For example, FACT-AAMM-XXXXN will give a number for the fourteenth invoice issued on 7 January 2023 - FACT- 2301-000014": "Par exemple, FACT-AAMM-XXXXN donnera un numéro pour la quatorzième facture émise le 7 janvier 2023 - FACT- 2301-000014",
  "For example, FACT-AAMM-XXXXN will give a number for the fourteenth invoice issued on 7 January 2023 - FACT-2301-000014": "Par exemple, FACT-AAMM-XXXXN donnera un numéro pour la quatorzième facture émise le 7 janvier 2023 - FACT-2301-000014",
  "For fields with options (Type de client, Type TVA client, Forme juridique), use the exact codes shown": "Pour les champs avec options (Type de client, Type TVA client, Forme juridique), utiliser les codes exacts affichés",
  "For fields with options (Type de client, Type TVA client, Forme juridique), you must use the exact codes shown (e.g., 'en', 'LOC', 'SARL'). The codes are case-sensitive.": "Pour les champs avec options (Type de client, Type TVA client, Forme juridique), vous devez utiliser les codes exacts affichés (ex: 'en', 'LOC', 'SARL'). Les codes sont sensibles à la casse.",
  "Format & Units": "Format & unités",
  "Format for budget numbering": "Format pour la numérotation des budgets",
  "Format for client numbering": "Format pour la numérotation des clients",
  "Format for delivery numbering": "Format pour la numérotation des livraisons",
  "Format for invoices numbering": "Format pour la numérotation des factures",
  "Format for orders numbering": "Format pour la numérotation des commandes",
  "Format for payment in advance numbering": "Format de numérotation des factures d'acompte",
  "Format for receipt numbering": "Format pour la numérotation des reçus",
  "Format for return numbering": "Format pour la numérotation des retours",
  "Formats": "Formats",
  "fortnightly": "bi-mensuel",
  "Fournisseur": "Fournisseur",
  "France": "France",
  "French": "Français",
  "Frequency": "Fréquence",
  "FULL": "T.Ext.",
  "FULL_display": "T.Ext. - Tenue extarnalisée",
  "General": "Général",
  "General accounts length": "Généraux",
  "General information": "Informations générales",
  "Generation frequency and occurrences": "Fréquence de génération et occurrences",
  "Generation mode": "Mode de génération",
  "Get started": "Commencer",
  "Get Started": "Commencer",
  "Go back": "Retour",
  "Go to company settings": "Aller aux paramètres de l'entreprise",
  "Go to Dashboard": "Accéder au tableau de bord",
  "Go to Home": "Aller à la maison",
  "Grid": "Grille",
  "Group": "Facture",
  "Group dunning notices by customer": "Regrouper les relances par client",
  "HALF": "N.Dig.",
  "HALF_display": "N.Dig. - Newrai digital",
  "has changed to the status": "est passé à l'état",
  "Head office information": "Informations sur le siège social",
  "Header": "En-tête",
  "HelpDesk": "Support client",
  "Helpful information": "Informations utiles",
  "Hide phones & emails": "Masquer téléphones et emails",
  "History": "Historique",
  "Home": "Accueil",
  "How to define your numbering formats?": "Comment définir vos formats de numérotation ?",
  "HT": "HT",
  "HT : This option allows you to invoice classically in HT. The calculation will be done by adding the VAT. The price in the Products file will be given in HT (it will be possible to modify it punctually on the article).": "HT  : Cette option permet de Facturer classiquement en HT . Le calcul se fera en ajoutant la Tva. Le prix dans la fiche Produits sera à donner en HT (il sera possible de le modifier ponctuellement sur l’article).",
  "IBAN": "IBAN",
  "IBAN is missing": "IBAN manquant",
  "Id": "Id",
  "Identity": "Identité",
  "IDs": "IDs",
  "If a main address already exists and you create a new main address, the old one will be changed to type Other.": "Si une adresse principale existe et que vous créez une nouvelle adresse principale, l'ancienne sera changée en type Autre.",
  "If enabled, automatic reminders will be sent to clients for unpaid invoices.": "Si activé, des relances automatiques seront envoyées aux clients pour les factures impayées.",
  "If enabled, client numbering will be automatically generated.": "Si activé, la numérotation des clients sera générée automatiquement.",
  "Image must be smaller than 4MB!": "L'image doit être inférieure à 4 Mo !",
  "Import": "Import",
  "Import errors": "Erreurs d'importation",
  "Important": "Important",
  "Important Notes": "Remarques importantes",
  "In progress": "En cours",
  "In this case, you have three options": "Dans ce cas, vous disposez de trois possibilités",
  "Information": "Information",
  "Intracom VAT does not match the SIRET": "La TVA intracom ne correspond pas au SIRET",
  "Intracom VAT must be FR + 2-character key + 9-digit SIREN": "La TVA intracom doit être FR + clé de 2 caractères + SIREN de 9 chiffres",
  "Invalid format": "Format non valide",
  "Invalid intracom VAT key, please verify the number": "Clé de TVA intracom invalide, vérifiez le numéro",
  "Invalid SIRET check digit, please verify the number": "Clé de contrôle du SIRET invalide, vérifiez le numéro",
  "invoice": "Facture",
  "Invoice": "Facture",
  "INVOICE": "FACTURE",
  "Invoice address": "Adresse de facturation",
  "Invoice address details": "Détails de l'adresse de facturation",
  "Invoice amount": "Montant facturé",
  "Invoice display name": "Nom d'affichage de la facture",
  "Invoice Eclx. Tax": "Facture HT",
  "Invoice HT": "Facture HT",
  "Invoice including VAT means that all items in the invoice will be listed with their prices including VAT": "Facture incluant la TVA signifie que tous les articles de la facture seront listés avec leurs prix incluant la TVA",
  "Invoice nr": "N° de facture",
  "Invoice TTC": "Facture TTC",
  "Invoice VAT": "Facture TTC",
  "invoices": "Facture",
  "Invoices": "Factures",
  "Invoices format": "Factures",
  "Invoices number": "Prochain nº de facture",
  "Invoices to be drawn": "Facture(s) à prélever",
  "It can be requested in the event of a dispute": "Il peut vous être demandé en cas de litige.",
  "It can be requested in the event of a dispute.": "Elle peut être demandée en cas de litige.",
  "Item": "Article",
  "Keep editing": "Continuer l'édition",
  "Keywords #month/#MONTH/#YEAR allow to automatically integrate the date in the object of the invoices.": "Mots clés #month/#MONTH/#YEAR permettent d'intégrer automatiquement la date dans l'objet des factures.",
  "Label": "Étiquette",
  "Last doc. validated": "Dernière fact. validée",
  "late invoices": "factures en retard",
  "Late payment penalty": "Pénalité de retard",
  "Latest modified documents": "Derniers documents modifiés",
  "Latest Modified Documents": "Derniers documents modifiés",
  "Leave without saving": "Quitter sans enregistrer",
  "Left": "Gauche",
  "Legal Category": "Catégorie juridique",
  "Legal form": "Forme juridique",
  "Legal status": "Statut légal",
  "Length of counterparts": "Longueur des comptes",
  "Let's set up your workspace in just a few steps. We'll personalize NeoFact to fit your business needs.": "Configurons votre espace de travail en quelques étapes. Nous personnaliserons NeoFact selon les besoins de votre entreprise.",
  "Level 1": "Niveau 1",
  "Level 2": "Niveau 2",
  "Level 3": "Niveau 3",
  "Limited to 8 MB for attachments.": "Limité à 8 Mo pour les envois en pièces jointes.",
  "Line": "Ligne",
  "Line break": "Saut de ligne",
  "Loading": "Chargement",
  "Loading document lines...": "Chargement des lignes du document...",
  "Loading...": "Chargement ...",
  "Local sell counterpart": "Compte de ventes par défaut pour local",
  "Login": "Login",
  "Logo description": "Description du logo",
  "Logo position": "Position du logo",
  "Logout": "Déconnexion",
  "MAIN": "PRINCIPALE",
  "Main account": "Compte principal",
  "Main Bank": "Banque principale",
  "Main currency": "Monnaie principale",
  "Mandat": "Mandat",
  "mandatory for commercial invoices since 2013": "obligatoire pour les factures commerciales depuis 2013",
  "Mandats SEPA": "Mandats SEPA",
  "Max": "Max",
  "Maximum 2000 lines per file": "Maximum 2000 lignes par fichier",
  "Maximum number of decimal places to display for quantities": "Nombre maximum de décimales à afficher pour les quantités",
  "Mention and legal status": "Mention et statut juridique",
  "Message": "Message",
  "Min/Max entry date": "Date d'entrée min/max",
  "Missing information": "Informations manquantes",
  "Mobile": "Mobile",
  "Mobile phone": "Téléphone mobile",
  "Mode de paiement": "Mode de paiement ",
  "Model.xlsx": "Model.xlsx",
  "Mon. TTC": "Mon. TTC",
  "Mont. HT": "Mont. HT",
  "Montant HT": "Montant HT",
  "Montant TTC": "Montant TTC",
  "Month": "Mois",
  "monthly": "mensuel",
  "months_ago": " il y a {{ diffMonthsAgo }} mois",
  "Most used counterpart": "Comptes les plus utilisés",
  "N-1": "N-1",
  "Name": "Nom",
  "NeoFact has improved the layout of its invoices! Your selected": "NeoFact a amélioré le design de ses factures ! Votre modèle sélectionné",
  "New category": "Nouvelle catégorie",
  "New comment": "Nouveau commentaire",
  "New product": "Nouveau produit / service",
  "Newrai support": "Support Newrai",
  "Next": "Suivant",
  "NIC": "NIC",
  "NINEA": "NINEA",
  "NINEA must have 9 digits": "NINEA doit avoir 9 chiffres",
  "no": "Non",
  "No": "Non",
  "No access": "Pas d'accès",
  "No attachments": "Aucune pièce jointe",
  "No data available": "Aucune donnée disponible",
  "No documents found": "Aucun document trouvé",
  "No lines available": "Aucune ligne disponible",
  "Nº of documents": "Nº de documents ",
  "Nº of payments": "Nº de paiements",
  "No options": "Aucune option",
  "No Options": "Aucune option",
  "No priority tasks": "Aucune tâche prioritaire",
  "None": "Aucun",
  "NONE": "T.Cab.",
  "None selected": "Aucun sélectionné",
  "NONE_display": "T.Cab. - Tenue cabinet",
  "Not sent": "Non envoyé",
  "Not Started": "Pas commencé",
  "Not validated": "Non validé",
  "Note": "Note",
  "Notes": "Remarques",
  "Notes / Legal status": "Remarques / Statut légal",
  "Notes & Legal": "Rema. & Sta. légal",
  "Notes and comments": "Remarques et commentaires",
  "now features a modern, professional design.": "maintenant a un design moderne et professionnel.",
  "nr_documents_selected_produce": "Êtes-vous sûr de vouloir produire {{ nrDocumentsSelectedProduce }} document(s)?",
  "Number": "Numéro",
  "Number of days": "Nombre de jours",
  "Numeration": "Modèles & Numéros",
  "Object": "Objet",
  "Objet": "Objet",
  "Objet du document": "Objet du document",
  "Occurrences": "Occurrences",
  "Off": "Non",
  "Offer in progress": "Devis en attente",
  "OK": "OK",
  "On": "Oui",
  "On Validate should create a payment?": "Sur Valider devrait créer un paiement?",
  "Only validated documents are taken into account": "Seulement les documents validés sont pris en compte",
  "Oops Page Not Found": "Oops Page non trouvée",
  "Operation type": "Type d'opération",
  "Operation Type": "Type d'opération",
  "Operational category": "Catégorie de l'exploitation",
  "Operations": "Opérations",
  "OPS": "OPS",
  "Optional label for this attachment": "Libellé optionnel pour cette pièce jointe",
  "options": "options",
  "order": "Bon de commande",
  "ORDER": "COMMANDES",
  "Orders": "Commandes",
  "Orders format": "Commandes",
  "Orders number": "Proc. nº de commande",
  "Original": "Originale",
  "Original document preview": "Aperçu du document original",
  "Other": "Autre",
  "OTHER": "AUTRE",
  "Other currencies": "Autres devises",
  "Other sell counterpart": "Compte de ventes pa défaut, pour les autres pays",
  "Outer": "Externe",
  "Outstanding clients": "Encours clients",
  "overdue": "En retard",
  "Package cost counterpart": "Compte de frais d'emballage",
  "Page": "Page",
  "Page break": "Saut de page",
  "Page Not Found": "Page non trouvé",
  "paid": "Réglé",
  "Paid": "Payé",
  "PAID": "PAYÉ",
  "Paid document preview": "Aperçu payant du document",
  "Paiement": "Paiement",
  "Paiements": "Paiements",
  "partially paid": "Partiellement régle",
  "PARTICULAR": "Particulier",
  "Pay day": "Paiement le",
  "Payment": "Paiement",
  "Payment confirmation": "Confirmation de paiement",
  "Payment Date": "Date de paiement",
  "Payment date limit": "Échéance",
  "Payment Date Limit": "Échéance",
  "Payment deadline": "Date limite de paiement",
  "Payment Deadline": "Date limite de paiement",
  "Payment deadline method": "Échéance par défaut",
  "Payment in advance": "Facture d'acompte",
  "Payment in advance format": "Format facture d'acompte",
  "Payment in advance number": "Numéro facture d'acompte",
  "Payment limit": "Limite de paiement",
  "Payment method": "Mode de paiement",
  "Payment Method": "Mode de paiement",
  "Payment methods": "Modes de paiement",
  "Payment period": "Type de prélèvement",
  "Payment settings": "Paramètres de paiement",
  "Payment transactions": "Opérations de paiement",
  "payment_in_advance": "Facture d'acompte",
  "paymentInAdvance": "Acompte",
  "Payments": "Paiements",
  "Payments in advance": "Fac. d'Acompte",
  "Payments received": "Paiement reçu",
  "Percentage": "Pourcentage",
  "Period": "Période",
  "Periodic": "Périodique",
  "Periodic billing": "Facturation périodique",
  "Periodicals": "Périodiques",
  "Periods": "Périodes",
  "Phone": "Téléphone",
  "Phone number": "Numéro de téléphone",
  "Phone Numbers": "Téléphones",
  "Phones & emails": "Téléphones et emails",
  "Please check the form for errors": "Veuillez vérifier le formulaire pour les erreurs",
  "Please choose a product": "Veuillez sélectionner un produit / service",
  "Please create a currency before proceeding": "Veuillez créer une devise avant de continuer",
  "Please enter a valid email": "Veuillez entrer une adresse électronique valide",
  "Please enter valid email addresses.": "Veuillez entrer des adresses électroniques valides.",
  "Please select a company before starting to use the application": "Veuillez sélectionner une entreprise avant de commencer à utiliser l'application.",
  "Please select a company to view company data": "Veuillez sélectionner une entreprise pour afficher les données de l'entreprise.",
  "Please select or set a main currency.": "Veuillez sélectionner ou définir une devise principale.",
  "Please upload a file": "Veuillez télécharger un fichier",
  "Please wait, documents are downloading": "Veuillez patienter, les documents sont en cours de téléchargement",
  "Please write more than 3 numbers": "Veuillez écrire plus de 3 caractères",
  "Please write more than 4 characters": "Veuillez écrire plus de 4 caractères",
  "Portuguese": "Portugais",
  "Position": "Poste",
  "Postal code": "Code postal",
  "Postal Code": "Code postal",
  "Postcode": "Code postal",
  "Preferences": "Préférences",
  "Prefix": "Préfixe",
  "Prefix client counterpart code": "Préfixe code compte client",
  "Prefix provider counterpart code": "Préfixe code compte fournisseur",
  "Prerequisite - Product Families Required": "Prérequis - Familles de produits requises",
  "Preview": "Aperçu",
  "Preview your new template below and see how it enhances your business documents.": "Prévisualisez votre nouveau modèle ci-dessous et voyez comment il améliore vos documents commerciaux.",
  "Price": "Prix",
  "Price HT": "Prix HT",
  "Price TTC": "Prix TTC",
  "Prices by currency": "Tarifs",
  "Pricing information": "Informations tarifaires",
  "Priority tasks": "Tâches prioritaires",
  "Priority Tasks": "Tâches prioritaires",
  "Prix unitaire TTC": "Prix unitaire TTC",
  "Produce": "Proforma",
  "Produce document": "Produire document",
  "Produce documents": "Produire documents",
  "produce_total_documents": "Êtes-vous sûr de vouloir produire {{ totalDocuments }} document(s)?",
  "produced": "Proforma",
  "Produced": "Proforma",
  "PRODUCED": "Produit",
  "product": "Référence",
  "Product": "Produit / Service",
  "Product count": "Nº produits / services",
  "Product families (product types) must exist before importing products - create or import them first": "Les familles de produits (types de produits) doivent exister avant d'importer les produits - créez-les ou importez-les d'abord",
  "Product name on line": "Nom du produit sur la ligne",
  "Product price": "Prix du produit / service",
  "Product type": "Type de produit / service",
  "Production before tax per user": "Production HT par utilisateur",
  "Production per User": "Production par utilisateur",
  "Products": "Produits / Services",
  "Products / Services": "Produits / Services",
  "proforma": "Proforma",
  "Proforma": "Proforma",
  "Provider": "Fournisseur",
  "PU HT": "PU HT",
  "PU TTC": "PU TTC",
  "PUBLIC_ADMINISTRATION": "Administration Publique",
  "punctual": "ponctuel",
  "Purchase order": "Facture",
  "Purchase Order": "Facture",
  "Purchase price": "Prix d'achat",
  "PURCHASE_ORDER": "Factures",
  "Qté": "Qté",
  "Qty": "Qté",
  "quantity": "Quantité",
  "Quantity": "Quantité",
  "Quantity Tracking": "Suivi des quantités",
  "Quantity Tracking2": "Suivi des quantités 2",
  "quarterly": "trimestriel",
  "Quote pending": "Devis en attente",
  "Rate": "Taux",
  "RCS": "RCS (n° et ville d'immatriculation)",
  "Reactivate": "Réactiver",
  "Reactivate payment date limit": "Réactiver limite date de paiement",
  "Reactivate product": "Réactiver le produit / service",
  "read": "lu",
  "receipt": "reçu",
  "Receipt": "Reçus",
  "Receipt format": "Reçus",
  "Receipt number": "Prochain nº de reçu",
  "Receipts": "Reçus",
  "Receipts for the year": "Encaissements de l'exercice",
  "received": "vu",
  "Received": "Reçu",
  "Received and readed": "Reçue et lue",
  "Receivers": "Destinataires",
  "Recipients": "Destinataires",
  "Recommendation": "Recommandation",
  "Reconciliation": "Lettrable",
  "Recurrent": "Récurrent",
  "Reexport": "Réexporter",
  "Ref": "Ref",
  "Reference": "Référence",
  "Référence": "Référence",
  "Reference | Ref": "Référence|Réf",
  "Référence unique de Mandat (RUM)": "Référence unique de Mandat (RUM)",
  "References": "Références",
  "Refresh": "Actualiser",
  "Refresh page": "Rafraîchir la page",
  "Refuse": "Refusé",
  "Refuse document": "Refuser document",
  "refused": "Refusé",
  "Refused": "Refusé",
  "REFUSED": "Refusé",
  "Refused successfully": "Refusé avec succès",
  "Refuser": "Refuser",
  "Registered": "Enregistré",
  "Regulations": "Règlements",
  "Reject/Cancel remaining payments": "Refuser/Annuler paiements restants",
  "Rejected": "Rejeté",
  "Rem": "Rem",
  "Reminder for group documents": "Rappel pour les documents de groupe",
  "Remove from selection": "Supprimer de la sélection",
  "Required": "Requis",
  "Reset": "Réinitialiser",
  "Reset filters": "Réinitialiser filtres",
  "Reset to default": "Réinitialiser par défaut",
  "Resume periodic payment": "Reprendre paiement périodique",
  "Retransfer of a bulk to SSI": "Retransfer d'un lot vers SSI",
  "return": "Avoir",
  "Return": "Avoir",
  "RETURN": "Avoirs",
  "Return number": "Prochain nº d'avoir",
  "Returns": "Avoirs",
  "RETURNS": "AVOIRS",
  "Revenue for the year": "CA de l'exercice",
  "Revenues": "Chiffre d'affaires",
  "Right": "Droite",
  "Roll Back made with success": "Roll back fait avec succès",
  "Row": "Ligne",
  "RUM": "RUM",
  "Sale account": "Ventilation comptable",
  "Sale order": "Commande",
  "Sale Order": "Commande",
  "Sale vat": "Ventilation de TVA",
  "sale_order": "Commande",
  "SALE_ORDER": "Commandes",
  "Sales": "Ventilations",
  "Sales accounts": "Ventilations comptables",
  "Sales VAT": "Ventilations de TVA",
  "Save": "Sauvegarder",
  "Save & Go next": "Enregistrer et continuer",
  "Save & Next": "Enregistrer & Suivant",
  "Save & Preview": "Enregistrer et prévisualiser",
  "Save and preview document": "Enregistrer et prévisualiser",
  "Save short": "Sauv.",
  "Saved comments": "Commentaires",
  "Saved Successfully": "Sauvegardé avec succès",
  "Search": "Chercher",
  "Search by reference": "Rechercher par référence",
  "Search for an existing client": "Recherche d'un client existant",
  "Search in my invoices": "Rechercher dans mes factures ...",
  "Search or create ...": "Recherchez ou créez...",
  "See all": "Voir tout",
  "See all documents": "Voir tous les documents",
  "Select": "Sélectionner",
  "Select a file": "Choisir un fichier",
  "Select a font": "Choisir une police",
  "Select accounting firm": "Choisir un cabinet comptable",
  "Select address": "Sélectionner adresse",
  "Select all {{count}} documents_many": "Sélectionner les {{count}} documents",
  "Select all {{count}} documents_one": "Sélectionner le {{count}} document",
  "Select all {{count}} documents_other": "Sélectionner les {{count}} documents",
  "Select an option": "Sélectionnez une option",
  "Select Book": "Sélectionnez journal",
  "Select business activity": "Sélectionner l'activité commerciale",
  "Select category": "Sélectionner catégorie",
  "Select city": "Sélectionnez une ville",
  "Select client": "Sélectionner client",
  "Select company": "Sélectionnez une entreprise",
  "Select Company": "Sélectionnez une entreprise",
  "Select counterpart": "Sélectionner contrepartie",
  "Select country": "Sélectionnez le pays",
  "Select default counterpart": "Sélectionner contrepartie par défaut",
  "Select invoice": "Sélectionner facture",
  "Select legal structure": "Choisir structure juridique",
  "Select period": "Sélectionnez période",
  "Select postal code": "Sélectionnez code postal",
  "Select product type": "Sélectionnez type de produit / service",
  "Select sell book": "Sélectionner journal de vente",
  "Select type": "Sélectionner type",
  "Select unit": "Sélectionner l'unité",
  "Select vat": "Sélectionnez TVA",
  "Select VAT": "Sélectionner TVA",
  "select_all_rows_prefix": "Sélectionnez les",
  "select_all_rows_suffix": "lignes du tableau.",
  "Sell book": "Journal de vente",
  "semester": "tous les 6 mois",
  "Send": "Envoyer",
  "Send back to neoscan expert": "Renvoyer à neoscan expert",
  "Send back to SSI": "Renvoyer à SSI",
  "Send by email": "Envoyer par e-mail",
  "Send email": "Envoyer e-mail",
  "Send me a copy of the email": "M'envoyer une copie de l'email",
  "Send overdue email": "Envoyer e-mail en retard",
  "Send reminder": "Envoyer une relance",
  "sent": "envoyé",
  "Sent": "Envoyé",
  "Sent to": "Envoyé à",
  "SEPA Credential Identifier": "Identifiant d'identification SEPA",
  "SEPA identifier is missing": "L'identifiant SEPA est manquant",
  "SEPA Mandats": "Mandats SEPA",
  "Sepa order": "Sequence SEPA",
  "Sequence": "Séquence",
  "Service": "Service",
  "Set date to today": "Définir date à aujourd'hui",
  "Set to": "Régler sur",
  "Settings": "Paramètres",
  "Setup Accountings": "Configurer les comptabilités",
  "Setup company": "Configurer entreprise",
  "Setup Features": "Configurer fonctionnalités",
  "Setup formats": "Configurer formats",
  "Setup Payments": "Configurer paiements",
  "Setup Vats": "Configurer TVA",
  "Short Name": "Nom court",
  "Show exported documents": "Montrer les documents exportés",
  "Show phones & emails": "Afficher téléphones et emails",
  "Sign": "Signer",
  "Signé le": "Signé le",
  "Signed": "Signé",
  "Signed mandate in PDF format You can attach the mandate signed by your client to to keep it": "Mandat signé au format PDF Vous pouvez joindre le mandat signé par votre client pour le conserver",
  "Signed mandate in PDF format you can attach the mandate signed by your client to to keep it. ": "Mandat signé au format PDF, vous pouvez joindre le mandat signé par votre client pour le conserver. ",
  "Signed mandate in PDF format You can attach the mandate signed by your client to to keep it. ": "Vous avez la possibilité de joindre le mandat signé par votre client pour conserver ce dernier. ",
  "Signed mandate in PDF format you can attach the mandate signed by your client to to keep it. It can be requested in the event of a dispute.": "Mandat signé au format PDF vous pouvez joindre le mandat signé par votre client pour le conserver. Elle peut être demandée en cas de litige.",
  "Single line": "Ligne simple",
  "Siren": "Siren",
  "Siren must have 9 digits": "Siren doit avoir 9 chiffres",
  "Siret": "Siret",
  "SIRET": "SIRET",
  "SIRET must have 9 digits (SIREN) or 14 digits (SIRET), {{length}} entered": "Le SIRET doit contenir 9 chiffres (SIREN) ou 14 chiffres (SIRET), {{length}} saisis",
  "Size": "Taille",
  "Software": "Logiciel",
  "Some relationship wasn't successfully connected": "Une relation n'a pas été connectée avec succès",
  "Something went wrong on deleting": "Une erreur s'est produite lors de la suppression",
  "Sorry, the page you're trying to access does not exist.": "Désolé, la page à laquelle vous tentez d'accéder n'existe pas.",
  "Source": "Source",
  "Spanish": "Espagnol",
  "SSI type": "Type de SSI",
  "SSI Type": "Type de SSI",
  "Stamp section": "Section cachet",
  "Stamp Space": "Section cachet",
  "Start": "Début",
  "Start date": "Date de début",
  "Start day": "Début",
  "State": "État",
  "Stats Cards": "Cartes de statistiques",
  "status": "statut",
  "Status": "Statut",
  "Step {{current}} of {{total}}": "Étape {{current}} sur {{total}}",
  "Stop billing": "Arrêter la facturation",
  "Stop billing ": "Arrêter la facturation",
  "Sub-total": "Sous-total",
  "Subject of the invoice": "Objet de la facture",
  "Submit": "Soumettre",
  "Submited by": "Envoyée par",
  "subsidiary": "Centre",
  "Subsidiary": "Centre",
  "Subtotal": "Sous-total",
  "Successfully": "Avec succès",
  "Successfully created": "Créé avec succès",
  "Successfully imported": "L'importation a été effectuée avec succès",
  "Successfully sent": "Envoyé avec succès",
  "Successfully transferred": "Transfert effectué avec succès",
  "Suggested (SIREN)": "Suggéré (SIREN)",
  "Sum of all items above": "Somme de tous les articles ci-dessus",
  "Summary": "Résumé",
  "SURVEILLANCE": "Surv.",
  "SURVEILLANCE_display": "Surv. - Surveillance",
  "Table borders": "Bordure du tableau",
  "Table header color": "Couleur en-tête",
  "Tax rates": "Taux de TVA",
  "Telephone": "Téléphone",
  "Template": "Modèle",
  "Template 1": "Modèle 1",
  "Template 2": "Modèle 2",
  "Template 3": "Modèle 3",
  "Template 4": "Modèle 4",
  "Template language": "Langue facture",
  "Template Preview": "Prévisualisation du modèle",
  "Template watermark": "Modèle de filigrane",
  "Terms of validity": "Conditions de validité",
  "Text": "Texte",
  "Text background": "Fond du texte",
  "Text Color": "Texte",
  "Text color with background": "Texte avec fond",
  "Thank you": "Merci",
  "Thank you for taking the time to set up your configuration.": "Merci d'avoir pris le temps d'établir votre configuration.",
  "The After validation mode gives you the possibility to visualize the content of the invoice before generation for a possible adjustment.": "Le mode Après validation vous donne la possibilité de visualiser le contenu de la facture avant génération pour un ajustement éventuel.",
  "The amount cannot exceed {{percentage}}% or {{value}}": "Le montant ne peut pas dépasser {{percentage}}% ou {{value}}",
  "The Automatic mode allows you to automatically send your invoices to customers.": "Le mode Automatique permet d'envoyer automatiquement vos factures aux clients.",
  "The day is invalid for the month": "Le jour n'est pas valide pour le mois",
  "The document of type": "Le document de type",
  "The field in the line had an error and was ignored": "Le champ de la ligne comportait une erreur et a été ignoré",
  "The file must be in .xlsx, .xls, or .csv format": "Le fichier doit être en format .xlsx, .xls ou .csv",
  "The file must not contain more than 2000 lines": "Le fichier ne doit pas contenir plus de 2000 lignes.",
  "The invoice number must be unique, based on a chronological and continuous sequence.": "Le numéro de facture doit être unique, basé sur une séquence chronologique et continue.",
  "The line could not be imported": "La ligne n'a pas pu être importée",
  "The number of characters limit is 14": "Le nombre de caractères est limité à 14",
  "The number of occurrences to automatically stop the generation at the deadline. The generation can also be stopped at any time via the Numbers menu.": "Le nombre d'occurrences pour arrêter automatiquement la génération à l'échéance. La génération peut également être arrêtée à tout moment via le menu Nombres.",
  "The page you are looking for does not exist or has been moved": "La page que vous recherchez n'existe pas ou a été déplacée.",
  "The selected date on the document is earlier than the most recently validated document, please update the date.": "La date choisie sur le document est plus ancienne que la dernière facture validée, merci de mettre à jour la date.",
  "The tax authorities require that the invoice number be unique, based on a chronological and continuous sequence": "Les autorités fiscales exigent que le numéro de facture soit unique, basé sur une séquence chronologique et continue.",
  "The tax authorities require that the invoice number be unique, based on a chronological and continuous sequence.": "L'administration fiscale exige que le numéro de facture soit unique, basé sur une séquence chronologique et continue.",
  "The unique mandate reference must be unique in order to generate your direct debit files SEPA": "La référence unique de mandat doit être unique pour pouvoir générer vos fichiers de prélèvements SEPA.",
  "There are no documents to export": "Il n'y a aucun document à exporter",
  "There must be 2 or 4 A's": "Il doit y avoir 2 ou 4 A",
  "There was an error try again later or contact your support": "Il y a eu une erreur, essayez à nouveau plus tard ou contactez votre support.",
  "These settings are for preview purposes only": "Ces paramètres sont uniquement à des fins de prévisualisation",
  "Third parties accounts length": "Tiers",
  "This counterpart does not exist": "Ce compte n'existe pas",
  "This field is required": "Ce champ est requis",
  "This field only accept numbers": "Ce champ n'accepte que les chiffres",
  "This guide shows you the available columns and their valid options for importing client information. Make sure your file matches these specifications.": "Ce guide vous montre les colonnes disponibles et leurs options valides pour l'importation des informations du client. Assurez-vous que votre fichier correspond à ces spécifications.",
  "This guide shows you the available columns for importing categories. Make sure your file matches these specifications.": "Ce guide vous montre les colonnes disponibles pour l'importation des catégories. Assurez-vous que votre fichier correspond à ces spécifications.",
  "This guide shows you the available columns for importing products and services. Make sure your file matches these specifications and that all referenced categories and product families exist in your system.": "Ce guide vous montre les colonnes disponibles pour l'importation des produits et services. Assurez-vous que votre fichier correspond à ces spécifications et que toutes les catégories et familles de produits référencées existent dans votre système.",
  "This invoice was generated using": "Document généré par",
  "This is a description.": "Ceci est une description.",
  "This is a description. This is a description.": "Ceci est une description. Ceci est une description.",
  "This is how your invoices will look with the new template": "Voici à quoi vos factures ressembleront avec le nouveau modèle",
  "This note will appear or auto-fill the note field when creating invoices": "Cette note apparaîtra ou pré-remplira le champ note lors de la création de factures",
  "This note will auto-fill the note field when creating invoices": "Cette note pré-remplira automatiquement le champ note lors de la création de factures",
  "This option allows you to choose the default billing mode for all your future documents Invoice including VAT means that all items in the invoice will be listed with their prices including VAT": "Cette option vous permet de choisir le mode de facturation par défaut pour tous vos futurs documents Facture TTC signifie que tous les articles de la facture seront listés avec leurs prix TTC",
  "This option allows you to choose the default billing mode for all your future documents. Invoice including VAT means that all items in the invoice will be listed with their prices including VAT.": "Cette option vous permet de choisir le mode de facturation par défaut pour tous vos futurs documents. Facture incluant la TVA signifie que tous les articles de la facture seront listés avec leurs prix incluant la TVA.",
  "Tip": "Astuce",
  "Title": "Titre",
  "to": "au",
  "To be collected": "À prélever",
  "to be paid": "A régler",
  "To customize your template, navigate to": "Pour personnaliser votre modèle, naviguez vers",
  "To enable direct debits": "Pour activer les prélèvements",
  "To export": "Pour exporter",
  "To_be_paid": "A régler",
  "Today": "Aujourd'hui",
  "Top Customers": "Top clients",
  "Top customers (turnover excluding tax)": "Top clients (chiffre d'affaires HT)",
  "Total": "Total",
  "Total Balance": "Solde total",
  "Total days": "Nº jours",
  "Total Documents": "Total des documents",
  "Total in debt": "Solde",
  "Total Invoices": "Total des factures",
  "Total pages": "Pages totales",
  "Total Payments": "Total des paiements",
  "Total Returns": "Total des avoirs",
  "Total table items": "Total {{count}} éléments",
  "Total table items_many": "Total {{count}} éléments",
  "Total table items_one": "Total {{count}} élément",
  "Total table items_other": "Total {{count}} éléments",
  "Total table items_plural": "Total {{count}} éléments",
  "Total TE": "Total HT",
  "Total TTC": "Total TTC",
  "total_rows_selected_prefix": "Les",
  "total_rows_selected_suffix": "lignes de ce tableau sont sélectionnées.",
  "Tranfers": "Transfert de facturation",
  "Transfer to accounts": "Transfert en comptabilité",
  "TTC": "TTC",
  "TTC : This option will allow you to invoice in TTC. The price in the Products file will be given in VAT. The software will recalculate the price before tax according to the VAT rate.": "TTC : Cette option permettra de facturer en TTC. Le prix dans la fiche Produits sera à donner en TTC. Le logiciel recalculera le HT en fonction du taux de TVA.",
  "Turnover before tax": "Chiffre d'affaires HT",
  "Turnover before tax for the top 30 customers": "Chiffre d'affaires HT pour le top 30 client",
  "Tva": "VAT",
  "TVA": "TVA",
  "TVA Intracom": "TVA Intracom",
  "TVA Intracom.": "TVA Intracom.",
  "TVA Type": "Type de TVA",
  "Type": "Type",
  "Type de prélèvement": "Type de prélèvement",
  "Type de TVA": "Type de TVA",
  "Type of sampling": "Type de prélèvement",
  "Unexpected error": "Erreur inattendue",
  "Unique mandate reference (RUM)": "Référence Unique de Mandat (RUM)",
  "Unit": "Unité",
  "Unit measure": "Unité de mesure",
  "Unit of measure": "Unité de mesure",
  "Unit of measure codes must match existing units (u, kg, l, h, m, etc.)": "Les codes d'unité de mesure doivent correspondre aux unités existantes (u, kg, l, h, m, etc.)",
  "Unit price": "PU HT",
  "Unit price before tax": "Prix unitaire HT",
  "Unit price including tax": "Prix unitaire TTC",
  "Unit price including VAT": "Prix unitaire TTC",
  "unitMeasure": "Unité de mesure",
  "unitPrice": "PU TTC",
  "Units of measure": "Unités de mesure",
  "unrecoverable": "Irrécouvrable",
  "Unsaved changes": "Modifications non enregistrées",
  "Update": "Mise à jour",
  "Update account": "Actualiser compte",
  "Update address": "Actualiser l'adresse",
  "Update contact": "Modifier contact",
  "update date for today": "date de mise à jour pour aujourd'hui",
  "Update date for today": "Date de mise à jour pour aujourd'hui",
  "Update export configuration": "Mettre à jour configuration d'exportation",
  "Update payment": "Mise à jour du paiement",
  "Update payment date": "Mise à jour date de paiement",
  "Update periodic billing": "Mettre à jour la facturation périodique",
  "Update product": "Mettre à jour le produit / service",
  "Update sale account": "Mettre à jour ventilation comptable",
  "Update sale vat": "Mettre à jour ventilation de TVA",
  "Update sepa order": "Mise à jour mandat",
  "Update template": "Mise à jour modèle",
  "Update VAT": "Mise à jour TVA",
  "Update vat type": "Mettre à jour type de TVA",
  "Updated successfully": "Mise à jour effectuée avec succès",
  "Upload": "Télécharger",
  "Upload files that will be automatically attached to emails. Use the checkboxes to select which document types include each attachment.": "Téléchargez des fichiers qui seront automatiquement joints aux e-mails. Utilisez les cases à cocher pour sélectionner les types de documents concernés.",
  "Uploaded file": "Fichier téléchargé",
  "Uploaded to Interops": "Téléchargé sur Interops",
  "Use the example": "Utilisez l'exemple",
  "Valid Date": "Date de validité",
  "Valid until": "Valable jusqu'au",
  "Validate": "Valider",
  "Validate document": "Valider document",
  "validate documents": "Valider des documents",
  "Validate payment": "Valider paiement",
  "validate_total_documents": "Êtes-vous sûr de vouloir valider {{ totalDocuments }} document(s)?",
  "validated": "Validé",
  "Validated": "Validé",
  "VALIDATED": "Validé",
  "Validated Successfully": "Validé avec succès",
  "Validity date": "Date de validité",
  "Value": "Valeur",
  "vat": "TVA",
  "Vat": "TVA",
  "VAT": "TVA",
  "VAT account": "Compte TVA",
  "VAT at": "TVA à",
  "VAT Intracom": "TVA Intracom",
  "Vat number": "Numéro de TVA",
  "Vat Number": "Numéro de TVA",
  "VAT Number": "Numéro de TVA",
  "VAT rate": "Taux de TVA",
  "Vat type": "Type de TVA",
  "VAT Type": "Type de TVA",
  "Vats": "TVA",
  "View": "Voir",
  "View all": "Voir tout",
  "View receipt": "Voir le reçu",
  "Volume": "Volume vendu",
  "Watermark opacity": "Opacité du filigrane",
  "We appreciate your commitment to personalizing your experience and hope that you find our site to be an enjoyable and valuable resource. Should you have any questions or encounter any difficulties during the setup process, our dedicated support team is always here to assist you.": "Nous apprécions votre engagement à personnaliser votre expérience et espérons que vous trouverez notre site agréable et précieux. Si vous avez des questions ou si vous rencontrez des difficultés au cours du processus d'installation, notre équipe d'assistance est toujours là pour vous aider.",
  "We are thrilled to have you here. Before we delve into the exciting content and features of our site, we would like to highlight the importance of setting up the configuration to ensure you have the best possible user experience.": "Nous sommes ravis de vous accueillir sur notre site. Avant de nous plonger dans le contenu et les fonctionnalités passionnantes de notre site, nous aimerions souligner l'importance de la configuration pour vous garantir la meilleure expérience utilisateur possible.",
  "We recommend that you avoid numbering containing sequence breaks such as AAMMXXXX": "Nous vous recommandons d'éviter les numérotations contenant des ruptures de séquence comme AAMMXXXX.",
  "We recommend that you avoid numbering containing sequence breaks such as AAMMXXXX.": "Nous vous recommandons d'éviter les numérotations contenant des ruptures de séquence telles que AAMMXXXX.",
  "We're excited to have you join us! Let's take a moment to set up your configuration for the best possible experience. This quick process will help personalize NeoFact to your needs.": "Nous sommes ravis de vous accueillir ! Prenez un moment pour configurer votre expérience pour la meilleure expérience possible. Ce processus rapide vous aidera à personnaliser NeoFact à vos besoins.",
  "weekly": "hebdomadaire",
  "Welcome": "Bienvenue",
  "welcome page": "Page d'accueil",
  "Welcome to NeoFact": "Bienvenue à NeoFact",
  "What we'll set up": "Ce que nous allons configurer",
  "when using this mandate for the first time": "lorsque vous utilisez pour la première fois ce mandat",
  "when you are going to make the last withdrawal to close the mandate": "lorsque vous allez effectuer le dernier prélèvement pour clôturer le mandat",
  "when you have already made direct debits with this mandate": "lorsque vous avez déjà effectué des prélèvements avec ce mandat",
  "Who is the receiver?": "Qui est le destinataire ?",
  "with an amount of": "d'un montant de",
  "Work": "Travail",
  "Year": "Année",
  "yearly": "annuel",
  "yes": "Oui",
  "Yes": "Oui",
  "You are logged out": "Vous êtes déconnecté",
  "You can only attach up to {{count}} files._many": "Vous ne pouvez joindre que {{count}} fichiers au maximum.",
  "You can only attach up to {{count}} files._one": "Vous ne pouvez joindre que {{count}} fichier au maximum.",
  "You can only attach up to {{count}} files._other": "Vous ne pouvez joindre que {{count}} fichiers au maximum.",
  "You can only upload JPG/PNG file!": "Vous ne pouvez télécharger que des fichiers JPG/PNG!",
  "You can use the strings AA or AAAA for the year, MM for the month, X for the marking pattern and N for the invoice number": "Vous pouvez utiliser les chaînes AA ou AAAA pour l'année, MM pour le mois, X pour le motif de marquage et N pour le numéro de facture.",
  "You can use the strings AA or AAAA for the year, MM for the month, X for the marking pattern and N for the invoice number.": "Vous pouvez utiliser les chaînes AA ou AAAA pour l'année, MM pour le mois, X pour le modèle de marquage et N pour le numéro de facture.",
  "You can use the strings AA or AAAA for year, MM for month and X for dialing pattern.": "Vous pouvez utiliser les chaines AA ou AAAA pour année, MM pour mois et X pour le modèle de la pièce.",
  "You can use the strings AA or AAAA for year, MM for month and X for dialling pattern": "Vous pouvez utiliser les chaînes AA ou AAAA pour l'année, MM pour le mois et X pour le motif de numérotation.",
  "You can't produce the documents below, because the date is before the last valid date.": "Vous ne pouvez pas valider les documents ci-dessous, car la date est antérieure à la dernière date valide.",
  "you can't validate the documents below, because the date is before the last valid date.": "Vous ne pouvez pas valider les documents ci-dessous, car la date est antérieure à la dernière date valide.",
  "You cannot change the export configuration because there are validated documents.": "Vous ne pouvez pas modifier la configuration d'exportation car il y a des documents validés.",
  "You do not have access to this application": "Vous n'avez pas accès à cette application",
  "You have unsaved changes in the main form. Save or discard them before editing this section.": "Vous avez des modifications non enregistrées dans le formulaire principal. Enregistrez-les ou abandonnez-les avant de modifier cette section.",
  "You have unsaved changes. Do you want to save before leaving?": "Vous avez des modifications non enregistrées. Voulez-vous les enregistrer avant de quitter ?",
  "You're all set!": "Tout est prêt !",
  "Your mandate is either defined for a one-off direct debit (Punctual) or for a recurring direct debit. ": "Votre mandat est soit défini pour un prélèvement unique (Ponctuel), soit pour un prélèvement récurrent.",
  "Your workspace is configured and ready to go. Start exploring your dashboard.": "Votre espace de travail est configuré et prêt à l'emploi. Commencez à explorer votre tableau de bord.",
  "This document": "Ce document",
  "Last validated invoice": "Dernière facture validée",
  "Date is earlier than the last validated invoice": "Date antérieure à la dernière facture validée",
  "New date:": "Nouvelle date :",
  "Allowed dates": "Dates autorisées",
  "Other date": "Autre date",
  "Your changes could not be saved": "Vos modifications n'ont pas pu être enregistrées",
  "Duplicate the last saved version instead? Your unsaved changes will not be copied.": "Dupliquer plutôt la dernière version enregistrée ? Vos modifications non enregistrées ne seront pas copiées."
}
